// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1956":"52b30d64","3446":"cb53292c","5768":"d1c82058"}[chunkId] + ".chunk.css";
};